var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner",style:(_vm.style),attrs:{"aria-label":_vm.ariaLabel,"role":"image"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }